export function getDurationValue(duration: string | number | undefined): number | undefined {
  if (typeof duration === 'string') {
    const parsed = duration.includes('m') ? parseInt(duration) : Number(duration);
      return isNaN(parsed) ? undefined : parsed * 60;
  }
  return typeof duration === 'number' ? duration * 60 : undefined;
}
